module.exports = __webpack_public_path__ + "img/pt.51056ebc.svg";